// Require

const { id, log, abs, limit, defer, delay } = require("../std/index")

const { allSlices, onSliceAdded } = require("../slices/index")
const { getInstanceFrom } = require("../widgets/index")

const { SliceDebugger } = require("../slices/debugger")


//
// Slice Controller
//

module.exports = class SliceController {
  constructor($page, $$) {
    const DEBUG = true;

    this.NullSlice = { type: id };

    const $html = $('html');
    const $body = $('body');
    this.$win = $(window);

    // Dom
    this.dom = {
      main: $page,
      footer: $('footer', $page),
      surrogate: $('.surrogate', $page)
    };

    // State
    this.state = {
      progress: 0,
      activeSlice: this.NullSlice,
      footerHeight: this.getFooterHeightContribution(),
      illusionHeight: 0,
      illusionMargin: 0
    };

    // Sub-components
    //this.title = getInstanceFrom($('[data-widget="fancy-title"]'));

    if (DEBUG) {
      this.debug = new SliceDebugger(this.dom.surrogate.outerHeight(), window.innerHeight, $body[0]);
      for (const [sid, slice] of Object.entries(allSlices)) {
        this.debug.addSlice(slice);
      }
    }

    // Listeners
    $(document).on('scroll', this.onScroll.bind(this));
    $(window).on('resize', this.measurePage.bind(this));

    // Monitor for late-added slices
    onSliceAdded(log);

    // Init
    $body.append(this.dom.surrogate);
    //this.pollForHeightChanges();
    //this.measurePage(); // Temp
    this.onScroll();
  }

  pollForHeightChanges() {
    this.measurePage();
    delay(500, this.pollForHeightChanges.bind(this));
  }

  titleRespondToSliceProgress(type, p1, p2, p3) {
    switch (type) {
      case 'specials':
        this.title.seek(p1 + p2 + p3);
        break;
      case 'top':
        this.title.seek(0);
        break;
      default:
        this.title.seek(3);
    }
  }

  onScroll() {
    const top = this.$win.scrollTop();

    this.state.illusionMargin = 0;
    this.state.activeSlice = this.NullSlice;

    for (const [sliceId, slice] of Object.entries(allSlices)) {
      slice.onScroll(top);
      this.state.illusionMargin += slice.state['illusion-offset'];

      if (0 < slice.state.progress && slice.state.progress < slice.state.scrollFactor) {
        this.state.activeSlice = slice;
      }
    }

    //TweenMax.set(this.dom.main, { y: this.state.illusionMargin - top });

    if (this.debug) this.debug.setDimensions(this.dom.surrogate.outerHeight(), window.innerHeight);
    if (this.debug) this.debug.setOffset(top);

    // Class-based mode for title (use title-respond-to-slice-progress for normal mode)
    //this.title.seek(top);

    if (top === 0) {
      //this.titleRespondToSliceProgress('top');
    } else if (this.state.activeSlice !== this.NullSlice) {
      const type = this.state.activeSlice.type();
      const p = this.state.activeSlice.state.progress;
      const p1 = limit(0, 1, p);
      const p2 = limit(0, 1, p - 1);
      const p3 = limit(0, 1, p - 2);
      //this.titleRespondToSliceProgress(type, p1, p2, p3);
    }
  }

  measurePage() {
    this.state.illusionHeight = 0;

    for (const [sid, slice] of Object.entries(allSlices)) {
      slice.updateSelf();
      this.state.illusionHeight += slice.state.scrollHeight;

      if (slice.undiscovered()) {
        this.discoverSlice(slice);
      }
    }

    //this.dom.surrogate.height(this.state.illusionHeight + this.getFooterHeightContribution());
    this.onScroll();
  }

  getFooterHeightContribution() {
    return this.dom.footer.outerHeight() + parseInt(this.dom.footer.css('margin-top'));
  }

  discoverSlice(slice) {
    //this.dom.surrogate.append(slice.getSurrogate());
  }
};
